// @ts-check
/** Admin in-person (pop-up) sales: record a sale and the end-of-day summary. */

import api from '../utils/apiClient';

const adminPosOrderService = {
  /**
   * @param {Object} data body built by buildPosPayload
   * @returns {Promise<{id: string, order_number: string, total: number, payment_method: string,
   *   payment_status: string, order_status: string, pay_path: string | null, created: boolean}>}
   */
  async createPosOrder(data) {
    return api.post('/api/admin/pos-orders', data);
  },

  /**
   * Every sellable product with its variants, loaded once when the sale form opens.
   * @returns {Promise<{products: Array<{product_id: string, name: string, slug: string, image: string | null,
   *   price: number, sale_price: number | null, variants: Array<{variant_id: string, size: string | null,
   *   color: string | null, color_hex: string | null, sku: string | null, stock_quantity: number}>}>}>}
   */
  async getCatalog() {
    return api.get('/api/admin/pos-orders/catalog');
  },

  /**
   * @param {{event_id?: string, day?: string}} [params] day is YYYY-MM-DD, an India calendar day
   * @returns {Promise<{paid: {count: number, total: number}, awaiting: {count: number, total: number},
   *   by_method: Record<string, {count: number, total: number}>}>}
   */
  async getSummary(params = {}) {
    const query = new URLSearchParams();
    if (params.event_id) query.append('event_id', params.event_id);
    if (params.day) query.append('day', params.day);
    return api.get(`/api/admin/pos-orders/summary?${query}`);
  },
};

export default adminPosOrderService;
